import { render, staticRenderFns } from "./InscricaoEstadualField.vue?vue&type=template&id=0b220f24&scoped=true&"
import script from "./InscricaoEstadualField.vue?vue&type=script&lang=js&"
export * from "./InscricaoEstadualField.vue?vue&type=script&lang=js&"
import style0 from "./InscricaoEstadualField.vue?vue&type=style&index=0&id=0b220f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b220f24",
  null
  
)

export default component.exports